import React from "react";
import AgentLayout from "../../../agentComponents/AgentLayout";
import CampaignMonitor from "./CampaignMonitor";

const CampaignMonitorView = () => (
  <AgentLayout title="Campaign Monitor" subtitle="Live campaign activity.">
    <CampaignMonitor />
  </AgentLayout>
);

export default CampaignMonitorView;
